const cfg = {
  VUE_APP_BASE_HOST: 'https://ris-cloud.rimagdata.com',
  VUE_APP_BASE_API: 'https://ris-cloud.rimagdata.com/beetle/doctor/api'
}
export default cfg
